import { put, call, takeEvery } from "redux-saga/effects";
import { toast } from "sonner";
import ApiConstants from "../../Globals/ApiConstants";
import AppConstants from "../../Globals/AppConstants";
import { apparelAxiosApi } from "../http/apparelAxiosApi";
import {
    addCategoryQuery,
    addProductQuery, addSubCategoryQuery, apparelLoginQuery, creatOrUpdateAttachmentQuery, createBillQuery, createBillQuery_V2, createCustomerQuery, mergeCustomerQuery,
    setCustomerCreditLimitQuery, addCustomerCreditOpeningBalanceQuery, recordCustomerCreditSettlementQuery, getCustomerCreditLedgerQuery,
    createOrUpdateBannerQuery,
    createOrUpdateCycleCountQuery,
    createOrUpdateHotNewTopPickQuery,
    createOrUpdateProcurementQuery,
    createOrUpdateSalesReturnQuery,
    createOrUpdateVendorQuery,
    getEmployeeListQuery,
    createOrUpdateEmployeeQuery,
    getEmployeeDropDownListQuery,
    getAttachmentQuery,
    getVendorBillAttachmentQuery,
    getVendorDebtAttachmentQuery,
    getBannerAttachmentQuery,
    getBillingListQuery, getCategoryQuery, getCoreCategoryMetaQuery, getCustomerHistoryQuery, getEmployeeSalesHistoryQuery, getCustomerListQuery,
    sendLoginOtpQuery, verifyLoginOtpQuery,
    getCycleCountListQuery,
    getCycleCountReportListQuery,
    getDashboardDataQuery,
    getTopProductsQuery,
    getTopCustomersQuery,
    getSalesDashboardDataQuery,
    getInventoryDashboardDataQuery,
    getCustomerDashboardDataQuery,
    getVendorDashboardDataQuery,
    getCustomerCreditDashboardDataQuery,
    getVendorDebtDashboardDataQuery,
    getEmployeeDashboardDataQuery,
    getCustomDashboardDataQuery,
    getUpcomingCustomerEventsQuery,
    getHotNewTopPickQuery,
    getInvoiceDetailsQuery, getMetaBannerQuery, getMultipleInventoryCountsQuery, getMultipleInventoryDamagedListQuery,
    getMultipleInventorySoldListQuery, getMultipleScrapListQuery, getMultipleSubcategoryListQuery,
    getOnlineOrderQuery,
    getProcurementQuery, getProcurementExportListQuery, getAuditLogListQuery, getProductHistoryQuery,
    getProductItemQuery, getProductListCategoryQuery, getProductListQuery,
    getReferenceDataQuery, getReportListQuery,
    getSalesReturnBasedOnProductIdQuery, getSalesReturnBillDetailsQuery, getSalesReturnQuery,
    getVenderDropDownListQuery,
    getVendorPurchaseListQuery, createOrUpdateVendorPurchaseQuery, getVendorPurchaseHistoryQuery,
    getRentalListQuery, createOrUpdateRentalQuery,
    getVendorDebtLedgerQuery, createVendorDebtEntryQuery,
    getMrpListQuery,
    getVenderEmailValidationQuery, getVendorListQuery, getupdateCycleCountProductQuery,
    updateCycleCountListQuery, updateMultipleInventoryQuery,
    updateOrdersQuery,
    updateProductItemColorOrSizeQuery, updateProductStatusQuery, updateStickeringStatusQuery,
    getStockHistoryQuery, adminAdjustStockQuery, getStockMovementHistoryQuery,
    getComboComponentOptionsQuery, getComboItemsQuery,
    getAttendanceListQuery, getEmployeeAttendanceCalendarQuery, getEmployeeAttendanceSummaryQuery, getAttendanceRecordByIdQuery, markAttendanceQuery,
    getFeedbackDashboardDataQuery, getFeedbackListQuery, getFeedbackLocationsQuery
} from "./apparelGraphQlQueries";

function* failSaga(result: any) {
    yield put({ type: ApiConstants.API_USER_FAIL });
    let msg = result.result.data
        ? result.result.data.message
        : AppConstants.somethingWentWrong;
    toast.error(msg);
}

function* errorSaga(error: any) {
    yield put({
        type: ApiConstants.API_USER_ERROR,
        error: error,
        status: error.status,
    });

    toast.error(AppConstants.somethingWentWrong);
}

export function* getListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getList, action.payload);
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createCustomerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createCustomer, createCustomerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_CUSTOMER_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* mergeCustomerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.mergeCustomer, mergeCustomerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_MERGE_CUSTOMER_SUCCESS,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* setCustomerCreditLimitSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.setCustomerCreditLimit, setCustomerCreditLimitQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_SET_CUSTOMER_CREDIT_LIMIT_SUCCESS,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* addCustomerCreditOpeningBalanceSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.addCustomerCreditOpeningBalance, addCustomerCreditOpeningBalanceQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_SUCCESS,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* recordCustomerCreditSettlementSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.recordCustomerCreditSettlement, recordCustomerCreditSettlementQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_SUCCESS,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getCustomerCreditLedgerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCustomerCreditLedger, getCustomerCreditLedgerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CUSTOMER_CREDIT_LEDGER_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* updateProductItemColorOrSizeSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateProductItemColorOrSize, updateProductItemColorOrSizeQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* addProductSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.addProduct, addProductQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_ADD_PRODUCT_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* categoryAndSubCategoryListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.categoryAndSubCategoryList, getCategoryQuery(action.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CATEGORY_AND_SUBCATEGORY_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* updateProductStatusSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateProductStatus, updateProductStatusQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_PRODUCT_STATUS_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* updateStickeringStatusSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateStickeringStatus, updateStickeringStatusQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_STICKERING_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProductListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getProductList, getProductListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PRODUCT_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getCustomerListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCustomerList, getCustomerListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CUSTOMER_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getReferenceDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getReferenceData, getReferenceDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_REFERENCE_DATA_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProductItemSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getProductItems, getProductItemQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PRODUCT_ITEM_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createBillSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createBill, createBillQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_BILL_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createBillSaga_V2(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createBill_V2, createBillQuery_V2(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_BILL_V2_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getBillingListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getBillingList, getBillingListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_BILLING_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

// Same request as getBillingListSaga, dispatched to its own success type so
// useBillNavigation's single-invoiceId probes land in billNavigationRow
// instead of overwriting the Customer Bills table's billingList state.
export function* getBillNavigationRowSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getBillingList, getBillingListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_BILL_NAVIGATION_ROW_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* apparelLoginSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.apparelLogin, apparelLoginQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_APPAREL_LOGIN_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* sendLoginOtpSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.sendLoginOtp, sendLoginOtpQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_SEND_LOGIN_OTP_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* verifyLoginOtpSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.verifyLoginOtp, verifyLoginOtpQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_VERIFY_LOGIN_OTP_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getCustomerHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCustomerHistory, getCustomerHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CUSTOMER_HISTORY_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getEmployeeSalesHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getEmployeeSalesHistory, getEmployeeSalesHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_EMPLOYEE_SALES_HISTORY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProductHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getProductHistory, getProductHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PRODUCT_HISTORY_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getInvoiceDetailsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getInvoiceDetails, getInvoiceDetailsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_INVOICE_DETAILS_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* updateMultipleInventorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateMultipleInventory, updateMultipleInventoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_MULTIPLE_INVENTORY_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMultipleInventoryCountsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMultipleInventoryCounts, getMultipleInventoryCountsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.Api_GET_MULTIPLE_INVENTORY_COUNT_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMultipleInventorySoldListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMultipleInventorySoldList, getMultipleInventorySoldListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_MULTIPLE_INVENTORY_SOLD_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMultipleInventoryDamagedListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMultipleInventoryDamagedList, getMultipleInventoryDamagedListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateCycleCountSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateCycleCount, createOrUpdateCycleCountQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_CYCLE_COUNT_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getCycleCountListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCycleCountList, getCycleCountListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CYCLE_COUNT_LIST_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getAttendanceListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getAttendanceList, getAttendanceListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_ATTENDANCE_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getEmployeeAttendanceSummarySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getEmployeeAttendanceSummary, getEmployeeAttendanceSummaryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                requestPayload: action?.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getAttendanceRecordByIdSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getAttendanceRecordById, getAttendanceRecordByIdQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_ATTENDANCE_RECORD_BY_ID_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                requestPayload: action?.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getEmployeeAttendanceCalendarSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getEmployeeAttendanceCalendar, getEmployeeAttendanceCalendarQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                requestPayload: action?.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* markAttendanceSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.markAttendance, markAttendanceQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_MARK_ATTENDANCE_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}
export function* getStockHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getStockHistory, getStockHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_STOCK_HISTORY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getStockMovementHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getStockMovementHistory, getStockMovementHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_STOCK_MOVEMENT_HISTORY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* adminAdjustStockSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.adminAdjustStock, adminAdjustStockQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_ADMIN_ADJUST_STOCK_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getComboComponentOptionsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getComboComponentOptions, getComboComponentOptionsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_COMBO_COMPONENT_OPTIONS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getComboItemsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getComboItems, getComboItemsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_COMBO_ITEMS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status,
                payload: action.payload
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* cycleCountListSearch(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.cycleCountListSearch, getCycleCountListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CYCLE_COUNT_LIST_SEARCH_SUCCESS,
                //result: result.result.data.data,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMultipleSubcategoryListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMultipleSubCategoryList, getMultipleSubcategoryListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CATEGORY_SUBCATEGORY_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProductListCategorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getProductListCategory, getProductListCategoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PRODUCT_LIST_CATEGORY_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getUpdataCycleCountSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getupdateCycleCountProduct, getupdateCycleCountProductQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_UPDATE_CYCLE_COUNT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* updateCycleCountListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateCycleCountList, updateCycleCountListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_CYCLE_COUNT_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMultipleInventoryScrapListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMultipleScrapList, getMultipleScrapListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_MULTIPLE_SCRAP_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getCycleCountReportListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCycleCountReportList, getCycleCountReportListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_CYCLE_COUNT_REPORT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getReportListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getReportList, getReportListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_REPORT_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorList, getVendorListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateVendorSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateVendor, createOrUpdateVendorQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_VENDOR_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorPurchaseListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorPurchaseList, getVendorPurchaseListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_PURCHASE_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateVendorPurchaseSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateVendorPurchase, createOrUpdateVendorPurchaseQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_VENDOR_PURCHASE_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getRentalListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getRentalList, getRentalListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_RENTAL_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateRentalSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateRental, createOrUpdateRentalQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_RENTAL_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorPurchaseHistorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorPurchaseHistory, getVendorPurchaseHistoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_PURCHASE_HISTORY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorDebtLedgerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorDebtLedger, getVendorDebtLedgerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_DEBT_LEDGER_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createVendorDebtEntrySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createVendorDebtEntry, createVendorDebtEntryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_VENDOR_DEBT_ENTRY_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVenderEmailValidationSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorEmailValidation, getVenderEmailValidationQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_EMAIL_VALIDATION_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorDropDownListSaga(): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorDropDownListApi, getVenderDropDownListQuery());
        if (result.status == 1) {
            yield put({
                type: ApiConstants.VENDOR_DROP_DOWN_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMrpListSaga(): any {
    try {
        const result = yield call(apparelAxiosApi.getMrpListApi, getMrpListQuery());
        if (result.status == 1) {
            yield put({
                type: ApiConstants.MRP_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getEmployeeListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getEmployeeList, getEmployeeListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_EMPLOYEE_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateEmployeeSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateEmployee, createOrUpdateEmployeeQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_EMPLOYEE_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
            yield call(getEmployeeListSaga, { payload: { searchText: '', sortBy: 4, paging: { limit: 10, offset: 0 } } });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getEmployeeDropDownListSaga(): any {
    try {
        const result = yield call(apparelAxiosApi.getEmployeeDropDownListApi, getEmployeeDropDownListQuery());
        if (result.status == 1) {
            yield put({
                type: ApiConstants.EMPLOYEE_DROP_DOWN_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}


export function* createOrUpdateProcurementSaga(payload: any): any {

    try {
        const result = yield call(apparelAxiosApi.createOrUpdateProcurementApi, createOrUpdateProcurementQuery(payload?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_PROCUREMENT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProcurementSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getProcurementApi, getProcurementQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PROCUREMENT_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getProcurementExportListSaga(): any {
    try {
        const result = yield call(apparelAxiosApi.getProcurementExportList, getProcurementExportListQuery());
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_PROCUREMENT_EXPORT_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getAuditLogListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getAuditLogList, getAuditLogListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_AUDIT_LOG_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getSalesReturnSaga(payload: any): any {
    try {
        const result = yield call(apparelAxiosApi.getSalesReturnApi, getSalesReturnQuery(payload?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_SALES_RETURN_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateSalesReturnSaga(payload: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateSalesReturnApi, createOrUpdateSalesReturnQuery(payload?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_SALES_RETURN_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getSalesReturnBasedOnProductIdSaga(payload: any): any {
    try {
        const result = yield call(apparelAxiosApi.getSalesReturnBasedOnProductIdApi, getSalesReturnBasedOnProductIdQuery(payload?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getSalesReturnBillDetailsSaga(payload: any): any {
    try {
        const result = yield call(apparelAxiosApi.getSalesReturnBillDetailsApi, getSalesReturnBillDetailsQuery(payload?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_SALES_RETURN_BILL_DETAILS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* creatOrUpdateAttachmentSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateAttachmentAxios, creatOrUpdateAttachmentQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_OR_UPDATE_ATTACHMENT_SUCCESSS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getAttachmentSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getAttachmentAxios, getAttachmentQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_ATTACHMENT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorBillAttachmentSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorBillAttachmentAxios, getVendorBillAttachmentQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_BILL_ATTACHMENT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getVendorDebtAttachmentSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getVendorDebtAttachmentAxios, getVendorDebtAttachmentQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_VENDOR_DEBT_ATTACHMENT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* addCategorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.addCategoryAxios, addCategoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_ADD_CATEGORY_ON_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}


export function* createOrUpdateBannerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateBannerAxios, createOrUpdateBannerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_CREATE_UPDATE_BANNER_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getMetaBannerSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getMetBannerApi, getMetaBannerQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_BANNER_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }

    catch (error: any) {
        yield call(errorSaga, error);

    }
}

export function* getBannerAttachmentSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getBannerAttachmentApi, getBannerAttachmentQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_BANNER_ATTACHMENT_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }

    catch (error: any) {
        yield call(errorSaga, error);

    }
}

export function* addSubCategorySaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.addSubCategoryAxios, addSubCategoryQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_ADD_SUB_CATEGORY_ON_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getHotNewTopPickSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getHotNewTopPickAxios, getHotNewTopPickQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_GET_HOT_NEW_TOP_PICK_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* createOrUpdateHotNewTopPickSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.createOrUpdateHotNewTopAxios, createOrUpdateHotNewTopPickQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants.API_UPDATE_HOT_NEW_TOP_PICK_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    }
    catch (error: any) {
        yield call(errorSaga, error);
    }
}

export function* getOnlineOrderSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getOnlineOrderAxios, getOnlineOrderQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_ONLINE_ORDER_SUCCESS,
                result: result?.result?.data?.data?.getOnlineOrders,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* updateOrdersSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.updateOrderAxios, updateOrdersQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_UPDATE_ONLINE_ORDER_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getCoreCategoryMetaSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getCoreCategoryAxios, getCoreCategoryMetaQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_CORE_CATEGORY_META_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getTopProductsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getTopProductsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_TOP_PRODUCTS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    } catch (error) {
        console.log("Error_in_getTopProductsSaga " + error);
    }
}

export function* getTopCustomersSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getTopCustomersQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_TOP_CUSTOMERS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            });
        }
    } catch (error) {
        console.log("Error_in_getTopCustomersSaga " + error);
    }
}

export function* getSalesDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getSalesDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_SALES_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getInventoryDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getInventoryDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_INVENTORY_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getCustomerDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getCustomerDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_CUSTOMER_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getVendorDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getVendorDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_VENDOR_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getCustomerCreditDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getCustomerCreditDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getVendorDebtDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getVendorDebtDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_VENDOR_DEBT_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getUpcomingCustomerEventsSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getUpcomingCustomerEventsQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_UPCOMING_CUSTOMER_EVENTS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getEmployeeDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getEmployeeDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_EMPLOYEE_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getCustomDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getCustomDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_CUSTOM_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

// Feedback module — Dashboard (Reports > Dashboards > Feedback) and the
// Browse Feedback list screen. Both reuse apparelAxiosApi.getDashboardData
// (same single GraphQL endpoint every other dashboard/list query already
// posts to) — apparel-api's getFeedbackSummary/getFeedbackList resolvers do
// the actual proxying to the standalone feedback service.
export function* getFeedbackDashboardDataSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getFeedbackDashboardDataQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_FEEDBACK_DASHBOARD_DATA_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getFeedbackListSaga(action: any): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getFeedbackListQuery(action?.payload));
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_FEEDBACK_LIST_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

export function* getFeedbackLocationsSaga(): any {
    try {
        const result = yield call(apparelAxiosApi.getDashboardData, getFeedbackLocationsQuery());
        if (result.status == 1) {
            yield put({
                type: ApiConstants?.API_GET_FEEDBACK_LOCATIONS_SUCCESS,
                result: result?.result?.data?.data,
                status: result.status
            })
        }
    } catch (error) {
        yield call(errorSaga, error)
    }
}

